import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { Toast } from "react-bootstrap";
import AnnouncementKit from "../../data/AnnouncementKit";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";
import {BsFillXCircleFill} from "react-icons/bs";

export default function MessageItem({ messageItem, me, eventSlug = null }) {
  const [isVisible, setIsVisible] = useState(true);
  const announcementKit = new AnnouncementKit();
  const router = useRouter();

  useEffect(() => {
    if (messageItem) {
      if (announcementKit.hasSeenMessageId(messageItem.id)) {
        setIsVisible(false);
      }
    }
  }, []);

  function handleOnClose() {
    setIsVisible(!isVisible);
    announcementKit.setMessageItemIdToLocalStorage(messageItem.id);
  }

  function handleAcceptInvitation() {
    handleOnClose();
    if (messageItem.page?.kind == 0) {
      // Main Page
      router.push("/[event]/", messageItem.page.get_frontend_url);
    } else {
      router.push("/[event]/[page]", messageItem.page.get_frontend_url);
    }
  }

  function renderCloseButton() {
    return (
      <button
        onClick={handleOnClose}
        className="close-btn"
        type="button"
        data-dismiss="toast"
      >
      <img src="/assets/x-circle.svg"/>
      </button>
    );
  }

  function renderActionButtons() {
  
    if (messageItem.page) {
      return (
        <div
          className={"message_item_mobile"}
          style={{ flexWrap: "nowrap" }}
        >
          <div className={"message_item_mobile--active"} onClick={handleAcceptInvitation}>
            Join
          </div>
        
        </div>
      );
    }
  }
  return (
    <>
      <Toast
        show={isVisible}
        onClose={handleOnClose}
        style={{
          zIndex: 10,
        }}
      >
        {renderCloseButton()}
        <Toast.Body>
          <p>
            <strong className="me-auto">{messageItem.title}</strong>
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <p>
              {messageItem.description}
              {!isMobileOrTablet() && messageItem?.page && (
                <span
                  className="message_item--active"
                  onClick={handleAcceptInvitation}
                >
                  Join
                </span>
              )}
            </p>
            {isMobileOrTablet() && renderActionButtons()}
          </div>
        </Toast.Body>
      </Toast>
    </>
  );
}
